document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".card");

  items.forEach((item) => {
    const imgElement = item.querySelector(".product-img");
    const images = item.dataset.images.split(",");
    const banner = item.dataset.banner.trim(); // Ensure no whitespace issues
    let imageIndex = 0;
    let isBannerDisplayed = false;

    function cycleImages() {
      setTimeout(() => {
        if (isBannerDisplayed) {
          imageIndex = (imageIndex + 1) % images.length;
        } else {
          isBannerDisplayed = true; // Once the banner has been displayed, move to images
        }

        imgElement.style.transition = "opacity 0.8s ease-in-out"; // Smooth transition
        imgElement.style.opacity = "0";

        setTimeout(() => {
          imgElement.src = isBannerDisplayed ? images[imageIndex] : banner;
          imgElement.style.opacity = "1";
        }, 800); // Transition time

        cycleImages(); // Continue cycling
      }, 3000);
    }

    if (banner && banner !== "undefined") {
      // Show banner first for 3 seconds
      imgElement.style.opacity = "0";
      setTimeout(() => {
        imgElement.src = banner;
        imgElement.style.opacity = "1";
      }, 800);

      setTimeout(() => {
        isBannerDisplayed = false;
        cycleImages();
      }, 3000);
    } 
  });
});
